import { lazy, Suspense } from "react";
import { EmptyState, Pagination } from "@/shared/components";
import { useLegalApplicationsListPage } from "../../hooks";
import { ApplicationsHeader, ApplicationsPageSkeleton, ApplicationsFilter } from "./components";

const ApplicationsCardsView = lazy(() =>
  import("./components/ApplicationsCardsView").then((m) => ({ default: m.default })),
);

export default function LegalApplicationsPage() {
  const {
    data,
    isLoading,
    isError,
    filteredDocuments,
    pagination,
    pageDocuments,
    search,
    setSearch,
    dateRange,
    setDateRange,
    documentTypeFilter,
    setDocumentTypeFilter,
    statusFilter,
    setStatusFilter,
    documentTypeOptions,
    statusOptions,
    activeFilters,
    handleResetFilters,
    locale,
    t,
    readOnly,
    signingRestricted,
  } = useLegalApplicationsListPage();

  if (isLoading && !data) {
    return (
      <>
        <title>{t("meta.title")}</title>
        <section className="flex-1">
          <ApplicationsHeader />
          <ApplicationsPageSkeleton />
        </section>
      </>
    );
  }

  if (isError) {
    return (
      <>
        <title>{t("meta.title")}</title>
        <section className="flex-1">
          <ApplicationsHeader />
          <p className="mt-4 text-body-regular-md content-action-negative">{t("messages.error")}</p>
        </section>
      </>
    );
  }

  return (
    <>
      <title>{t("meta.title")}</title>
      <section className="flex-1">
        <ApplicationsHeader />
        <div className="radius-3xl surface-base-fill p-7">
          <ApplicationsFilter
            search={search}
            onSearchChange={setSearch}
            dateRange={dateRange}
            onDateRangeChange={setDateRange}
            documentTypeFilter={documentTypeFilter}
            onDocumentTypeChange={setDocumentTypeFilter}
            statusFilter={statusFilter}
            onStatusChange={setStatusFilter}
            documentTypeOptions={documentTypeOptions}
            statusOptions={statusOptions}
            hasActiveFilters={activeFilters}
            onReset={handleResetFilters}
            locale={locale}
          />

          {filteredDocuments.length === 0 ? (
            <EmptyState
              hasActiveFilters={activeFilters}
              noResultsText={t("table.noResults")}
              noDataText={t("table.noData")}
              noDataHint={t("table.noDataHint")}
            />
          ) : (
            <>
              <Suspense fallback={<ApplicationsPageSkeleton variant="cardsOnly" />}>
                <ApplicationsCardsView documents={pageDocuments} readOnly={readOnly} signingRestricted={signingRestricted} />
              </Suspense>
              <Pagination
                currentPage={pagination.page}
                totalPages={pagination.totalPages}
                onPageChange={pagination.setPage}
                fromItem={pagination.fromItem}
                toItem={pagination.toItem}
                total={filteredDocuments.length}
              />
            </>
          )}
        </div>
      </section>
    </>
  );
}
